module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "generatecode"
    },
    slot: "generatecode"
  }, [_c('div', {
    staticClass: "layui-form-item"
  }, [_c('v-button', {
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', [_vm._v("添加新项\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v("")])])]), _vm._v(" "), _c('v-button', {
    on: {
      "click": _vm.saveData
    }
  }, [_c('span', [_vm._v("保存数据\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-button', {
    attrs: {
      "icon": _vm.showMoreBtn ? 'right' : 'down'
    },
    on: {
      "click": function (s) { return _vm.showMoreBtn = !_vm.showMoreBtn; }
    }
  }, [_vm._v("更多")])], 1), _vm._v(" "), (_vm.showMoreBtn) ? _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left",
      "line-height": "38px"
    }
  }, [_vm._v("背景色:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bgcolor),
      expression: "form.bgcolor"
    }],
    staticClass: "layui-input",
    staticStyle: {
      "width": "100px",
      "padding-left": "0"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.form.bgcolor)
    },
    on: {
      "change": _vm.convert,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bgcolor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticStyle: {
      "float": "left",
      "margin-left": "5px",
      "margin-right": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left",
      "line-height": "38px"
    }
  }, [_vm._v("填充色：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.color),
      expression: "form.color"
    }],
    staticClass: "layui-input",
    staticStyle: {
      "width": "100px",
      "padding-left": "0"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.form.color)
    },
    on: {
      "change": _vm.convert,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "color", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showMoreBtn) ? _c('div', {
    staticClass: "layui-form-item "
  }, [_c('v-upload', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "beforeShow": true,
      "uploadApi": '/static/data/editorUpload.json'
    },
    on: {
      "before": _vm.addImage
    }
  }, [_c('v-button', {
    staticStyle: {
      "position": "absolute"
    }
  }, [_c('span', [_vm._v("上传 Logo\n            "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v("")])])])], 1), _vm._v(" "), (_vm.form.logoImg) ? _c('img', {
    staticStyle: {
      "width": "40px",
      "height": "40px",
      "margin-left": "5px"
    },
    attrs: {
      "src": _vm.form.logoImg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.logoImg) ? _c('button', {
    staticClass: "layui-btn layui-btn-danger layui-btn-mini",
    on: {
      "click": function (e) {
        this$1.form.logoImg = null;
        this$1.convert()
      }
    }
  }, [_c('i', {
    staticClass: "layui-icon"
  }, [_vm._v("")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataList), function(item, index) {
    return _c('fieldset', {
      key: 't_' + index,
      staticClass: "layui-elem-field"
    }, [_c('legend', [_vm._v("第" + _vm._s(_vm.dataList.length - index) + "项\n        "), _c('button', {
      staticClass: "layui-btn layui-btn-danger layui-btn-mini",
      on: {
        "click": function($event) {
          _vm.delItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "layui-icon"
    }, [_vm._v("")])])]), _vm._v(" "), _c('div', {
      staticClass: "layui-field-box"
    }, [_c('v-input-txt', {
      attrs: {
        "label": "文本/Url",
        "placeholder": "将要生成二维码的文本或链接",
        "rows": 2
      },
      on: {
        "change": _vm.convert
      },
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.text),
        expression: "item.text"
      }],
      attrs: {
        "src": item.src,
        "id": 'custom-img-' + (_vm.dataList.length - index)
      }
    })], 1)])
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "decode"
    },
    slot: "decode"
  }, [_c('div', {
    attrs: {
      "id": "qrfile",
      "qrCanvas": "qr-canvas",
      "qrResult": "qrcode_content"
    }
  }, [_c('div', {
    attrs: {
      "title": "把您的二维码拖到这儿，即可识别内容"
    }
  }, [_c('div', {
    staticClass: "browser",
    attrs: {
      "id": "canvas_ext_div"
    }
  }, [_c('label', {
    staticStyle: {
      "height": "30px",
      "line-height": "30px"
    }
  }, [_c('span', [_vm._v("选择要识别的二维码，粘贴剪切板或者拖动图片到面板中")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "files",
      "accept": "image/*",
      "id": "ewmfile",
      "title": "选择文件后自动识别"
    }
  })])])]), _vm._v(" "), _c('canvas', {
    staticStyle: {
      "border": "1px solid #CCC"
    },
    attrs: {
      "id": "qr-canvas"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("识别结果：\n      "), _c('p', {
    staticStyle: {
      "border": "1px solid #ccc",
      "line-height": "30px",
      "word-break": "break-all"
    },
    attrs: {
      "id": "qrcode_content"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2abbdcba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/qrcode.vue
// module id = 314
// module chunks = 2